// Assigned Dependencies
module.exports = (function() {
	var siteRoot = $("meta[name='site-root']").attr('content');
	var apiRoot = $("meta[name='api-root']").attr('content');

	window.lcb.config.apiRoot = apiRoot;
	window.lcb.config.apiPaths = {};
	window.lcb.config.apiPaths.ProgramCourseTags = apiRoot + 'api/programs/v2/webtags';
	window.lcb.config.apiPaths.ProgramCampuses = apiRoot + 'api/programs/v2/campuses';
	window.lcb.config.apiPaths.Programcourses = apiRoot + 'api/programs/v2/programcourses';
	window.lcb.config.apiPaths.CourseSessions = apiRoot + 'api/programs/v2/courses/{SEQ_COURSE}/sessions';
	window.lcb.config.apiPaths.ProgramsSessionGroups = apiRoot + 'api/programs/v2/programs/{SEQ_PROGRAM}/sessionGroups';
	window.lcb.config.apiPaths.ProgramsIntakes = apiRoot + 'api/programs/v2/programs/{SEQ_PROGRAM}/intakes';
	window.lcb.config.apiPaths.Campuses = apiRoot + "api/campuses";
	window.lcb.config.apiPaths.AddSessionToShoppingCart = siteRoot + "index.cfm?fa=ProgramsFrontMod.AddSessionToShoppingCart";
	window.lcb.config.apiPaths.AddSessionGroupToShoppingCart = siteRoot + "index.cfm?fa=ProgramsFrontMod.AddSessionGroupToShoppingCart";
	window.lcb.config.apiPaths.AddProgramIntakeToShoppingCart = siteRoot + "index.cfm?fa=ProgramsFrontMod.AddProgramIntakeToShoppingCart";
	window.lcb.config.apiPaths.RemoveFromShoppingCart = siteRoot + "index.cfm?fa=ProgramsFrontMod.RemoveFromShoppingCart";
	window.lcb.config.apiPaths.UpdateQuantityFromShoppingCart = siteRoot + "index.cfm?fa=ProgramsFrontMod.UpdateShoppingCart";
	window.lcb.config.apiPaths.BrochuresCategories = apiRoot + 'api/brochures/categories';
	window.lcb.config.apiPaths.BrochuresCampuses = apiRoot + 'api/brochures/campuses';

	window.lcb.config.apiPaths.PhotoGallery = apiRoot + "api/photogalleries?photogalleryID=";

	window.lcb.config.templatePaths = {};
	window.lcb.config.templatePaths.ShortCourses = siteRoot + 'assets/_templates/short-courses.html';
	window.lcb.config.templatePaths.ProgramCategories = siteRoot + 'assets/_templates/program-categories.html';
	window.lcb.config.templatePaths.NewsEvents = siteRoot + 'assets/_templates/news-events.html';
	window.lcb.config.templatePaths.OtherCourses = siteRoot + 'assets/_templates/other-courses.html';
	window.lcb.config.templatePaths.brochures = siteRoot + 'assets/_templates/brochures.html';
	window.lcb.config.templatePaths.brochuresForm = siteRoot + 'assets/_templates/brochures-form.html';
	window.lcb.config.templatePaths.quickApplyCourseDates = siteRoot + 'assets/_templates/quick-apply-radio-course-dates.html';
	window.lcb.config.templatePaths.quickApplyRadio = siteRoot + 'assets/_templates/quick-apply-radio.html';
	window.lcb.config.templatePaths.quickApplyPriceList = siteRoot + 'assets/_templates/quick-apply-price-list.html';
	window.lcb.config.templatePaths.quickApplyRadioCourses = siteRoot + 'assets/_templates/quick-apply-radio-courses.html';
	window.lcb.config.templatePaths.quickApplySeats = siteRoot + 'assets/_templates/quick-apply-seats.html';
	window.lcb.config.templatePaths.quickApplyWebtags = siteRoot + 'assets/_templates/quick-apply-webtags.html';


	window.lcb.config.templatePaths.schoolbag = siteRoot + 'assets/_templates/schoolbag.html';
	window.lcb.config.templatePaths.searchResults = siteRoot + 'assets/_templates/search-results.html';

	if ( typeof(deferredJS) !== "undefined" && deferredJS !== null ) {

		window.deferredJS.push( function(){
			$.blockUI.defaults.message = '<h1>'+ $.i18n._(13639) + '</h1>';
			$.blockUI.defaults.css = {
			padding:	0,
			margin:		0,
			width:		'50%',
			top:		'30%',
			left:		'25%',
			textAlign:	'center',
			color:		'#000',
			border:		'3px solid #aaa',
			backgroundColor:'#fff',
			cursor:		'wait'};
		});
	}

})();